<template>
    <div class="global-messenger"></div>
</template>

<script>
import './messenger';
export default {
    name: 'GlobalMessenger'
};
</script>

<style lang="scss" scoped></style>
